import { ProjectFileKey } from './ProjectFileKey'
import { TranslationFile } from './TranslationFile'

export interface ProjectFile {
    modified: boolean
    id: number
    projectFileName: string
    isUniqueValue: boolean
    maxKeyLen: number
    totalKeys: number
    exportFileName: string,
    fileType: languageFileType,
    translationKeys: Record<number, ProjectFileKey>
    translationFilesExpanded: Record<number, TranslationFile>
}

export function createProjectFile(): ProjectFile {
    return {
        modified: true,
        id: -1,
        projectFileName: '',
        isUniqueValue: false,
        maxKeyLen: 0,
        totalKeys: 0,
        exportFileName: '',
        fileType: languageFileType.appContent,
        translationKeys: {},
        translationFilesExpanded: {}
    }
}

export enum languageFileType {
    apacheLanguageFile,
    webDynpro,
    inApp,
    appContent,
    applicationLanguageFile,
    classificationLanguageFile
}